module.exports = __webpack_public_path__ + "img/pending_ib.f1de7718.svg";